// extracted by mini-css-extract-plugin
module.exports = {"clockIcon":"making-changes-to-my-delivery_clockIcon__gG7la"};